export const BASE_URL =
  // "http://192.168.1.20/knf-warehouse-laravel-script/public/crm/"; // local
  "https://sit-laravel.knf-inventory.ninositsolution.com/crm/";
// "https://uat-laravel.knf-inventory.ninositsolution.com/crm/"

export const URLS = {
  LOGIN: "user-login",
  FORGOT_PASSWORD: "user-forgot-password",
  RESET_PASSWORD: "reset-password",
  TOKEN_VERIFY: "token-verify",
  LOGOUT: "user-logout",
  ADMIN_LIST: "admin-lists",
  ADMIN_ADD: "add-admin",
  ADMIN_VIEW: "view-admin/",
  ADMIN_EDIT: "update-admin/",
  ADMIN_STATUS: "admin-status/",
  ADMIN_DELETE: "admin-delete/",
  ADMIN_ROLES: "total-role-list",
  ROLES_EDIT: "update-role",
  ROLES_LIST: "role-list",
  ROLES_ADD: "add-role",
  ROLES_VIEW: "view-role/",
  ROLES_STATUS: "role-status-change",
  ROLES_DELETE: "delete-role/",
  ROLES_PERMISSION: "permission-list",
  CATEGORY_LIST: "category/lists",
  CATEGORY_ADD: "category-add",
  CATEGORY_VIEW: "category-view/",
  CATEGORY_EDIT: "category-update/",
  CATEGORY_STATUS: "category-status/",
  CATEGORY_DELETE: "category/delete/",
  MASTER_LIST: "master-list",
  MASTER_ADD: "create-master",
  MASTER_VIEW: "view-master/",
  MASTER_EDIT: "update-master",
  MASTER_STATUS: "master-status-change",
  MASTER_DELETE: "delete-master/",
  ATTRIBUTES_LIST: "attribute-list",
  ATTRIBUTES_DROPDOWN: "attribute-listdropdown",
  ATTRIBUTES_VARIENT: "varient-listdropdown",
  PRIMARY_CATEGORY: "all-parent-categories",
  SUB_CATEGORY: "all-clild-category/",
  SUB_CATEGORY_ACTIVE: "active-clild-category/",
  MATERIAL_LIST: "material-list",
  MATERIAL_ADD: "material-create",
  MATERIAL_EDIT: "update-material/",
  MATERIAL_VIEW: "view-material/",
  MATERIAL_DELETE: "material-delete/",
  MATERIAL_STATUS: "material-status",
  CATEGORY_DROPDOWN: "category-dropdown",
  WAREHOUSE_ADD: "warehouse/create",
  WAREHOUSE_EDIT: "warehouse/update/",
  WAREHOUSE_LIST: "warehouse/list",
  WAREHOUSE_VIEW: "warehouse/view/",
  WAREHOUSE_ADMINS: "admins-list",
  PROJECT_ADD: "project/create",
  PROJECT_EDIT: "project/update/",
  PROJECT_LIST: "project/list",
  PROJECT_VIEW: "project/view/",
  PROJECT_ADMINS: "admins-list",
  LOCATION_DROPDOWN: "location-list",
  WAREHOUSE_STATUS: "warehouse/status/",
  PROJECT_STATUS: "project/status/",
  MATERIAL_IMAGE_DELETE: "delete-image/",
  WAREHOUSE_DROPDOWN: "warehouse/dropdown",
  PROJECT_DROPDOWN: "project/dropdown",
  MATERIAL_DROPDOWN: "material-dropdown",
  MATERIAL_DROPDOWN_CATEGORY: "material-dropdown-category",
  WAREHOUSE_MATERIAL_LIST: "warehouseMaterial-list",
  MATERIAL_FILTER: "material-filter",
  CATEGORY_FULL_LIST: "category-full-list",
  WAREHOUSE_MATERIAL_ADD: "warehouseMaterial-create",
  WAREHOUSE_MATERIAL_UPDATE: "warehouseMaterial-update/",
  WAREHOUSE_MATERIAL_VIEW: "warehouseMaterial-view/",
  PROJECT_MATERIAL_LIST: "projectMaterial-list",
  PROJECT_MATERIAL_ADD: "projectMaterial-create",
  PROJECT_MATERIAL_UPDATE: "projectMaterial-update/",
  PROJECT_MATERIAL_VIEW: "projectMaterial-view/",
  MATERIAL_RESERVED_LIST: "material-reserved-list",
  MATERIAL_RESERVED_WAREHOUSE: "warehouse-material-dropdown",
  MATERIAL_RESERVED_STORE: "material-reserved-store",
  MATERIAL_RESERVED_VIEW: "material-reserved-view/",
  MATERIAL_RESERVED_UPDATE: "material-reserved-update/",
  WAREHOUSE_MATERIAL_RESERVED_LIST: "warehouse-material-reserved-list",
  PROJECT_RESERVED_DELETE: "material-reserved-delete/",
  VIEW_WAREHOUSE_MATERIAL_LIST: "view-project-warehouse-list",
  WAREHOUSE_DROPDOWN_SELECT: "warehouse/details/dropdown",
  PROJECT_DROPDOWN_SELECT: "project/details/dropdown",
  CHECK_STOCK: "material-issued/check-stock",
  ISSUE_LIST_ADD: "material-issued/add",
  ISSUE_LIST_EDIT: "material-issued/update-material/",
  ISSUE_LIST_DELETE: "material-issued/delete-material/",
  ISSUE_ADD: "material-issued/upload-proof/",
  WAREHOUSE_ISSUE_VIEW: "material-issued/view/",
  ISSUE_LIST: "material-issued/list",
  ISSUE_VIEW_LIST: "material-issued/material-list/",
  RECEIVED_ACCEPT: "material-issued/accept-material/",
  RECEIVED_PROOFS_ACCEPT: "material-issued/upload-proof/receive/",
  IMAGES_DELETE: "warehouseMaterial-image-delete/",
  PROJECT_IMAGES_DELETE: "projectMaterial-image-delete/",
  PROJECT_REQ_LIST: "project-admins-list",
  PROJECT_MATERIAL_DROPDOWN: "project-material-dropdown",
  DASHBOARD_LIST: "dashboard",
  MATERIAL_DELETE: "material-delete/",
  WAREHOUSE_DELETE: "warehouse/delete/",
  PROJECT_DELETE: "project/delete/",
  CHECK_WAREPRO: "check-editable",
  MATERIAL_EDIT_CHECK: "material-check-editable/",
  WAREHOUSE_MATERIAL_DELETE: "warehouseMaterial-delete/",
  PROJECT_MATERIAL_DELETE: "projectMaterial-delete/",
  MATERIAL_WAR_PROJ_CREATE: "warehouse_project_material/create",
  MATERIAL_WAR_PROJ_LIST: "warehouse_Project_material/list",
};

export const TOKEN = "token";
export const LOGGEDUSER = "loggeduser";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";
export const LOCATION = "userlocation";
export const LOCATIONNAME = "locationname";
export const NUMBER = /^\+?(0|[6-9]\d*)$/;

export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*.?&])[A-Za-z\d@$!%.*?&]{8,}$/;
export const isValidEmail = (email) => {
  return EMAIL.test(email);
};

export const validatePassword = (pass) => {
  if (!pass) return "Enter password";
  if (!/[A-Z]/.test(pass)) return "Password must contain uppercase letters";
  if (!/[a-z]/.test(pass)) return "Password must contain lowercase letters";
  if (!/[0-9]/.test(pass)) return "Password must contain numbers";
  if (pass.length < 8) return "Password must be at least 8 characters";
  if (!/[!*@#%&()^~{}]/.test(pass))
    return "Password must contain a special character";
  return "";
};

export const validateConfirmPassword = (pass, confirmPass) => {
  if (!confirmPass) return "Enter confirm password";
  if (confirmPass !== pass) return "Passwords do not match";

  // Also check same password rules
  return validatePassword(confirmPass);
};

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const productDetailImg = {
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};

//Refer at https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions
export const formatKey = (key) => {
  return key
    .replace(/_/g, " ") // underscores to spaces
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase too split
    .replace(/\s+/g, " ") // simple spaces
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capital words
};

export const selectBoxFormater = (item, type) => {
  if (Array.isArray(item)) {
    let temp = [];
    item?.map((val, ind) => {
      if (type == "id") {
        temp.push({ name: val?.name, id: val?.id });
      } else {
        temp.push({ label: val?.name, value: val?.id });
      }
    });
    return temp;
  }
  return { label: item?.name, value: item?.id };
};
